import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const mediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CATEGORIES = [
  "All Products",
  "Harmonic Drives & Reducers",
  "Robotic Joint Modules",
  "Rotary Actuators & Servo",
  "QDD Motors",
  "Gimbal & Direct Drive (DD) Motors",
  "Frameless Torque Motors",
  "Micro Reducers & Actuators",
  "Robot End Effectors & Grippers",
  "Cycloidal Reducers",
];

export const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/86016e5a-65e4-4de5-8192-6cf922467de5/images/36c0b5448793d228b4593a0077c91063a32a0b722ac9074bd7b3b6505cc5aa85.jpeg";
